import {
  Exception
} from "./chunk-CQG3BCE6.mjs";

// src/exceptions/checkout.ts
var CheckoutException = class extends Exception {
  ticketErrors;
  constructor({ error, order, ticketErrors }) {
    super({
      error,
      context: {
        tags: { journey: "checkout" },
        level: "fatal",
        extra: { order: JSON.stringify(order), ticketErrors: JSON.stringify(ticketErrors || []) }
      },
      name: "CheckoutException"
    });
    if (ticketErrors) {
      this.processTicketErrors(ticketErrors);
    }
  }
  processTicketErrors(ticketErrors) {
    var _a;
    const errorObj = {};
    for (const error of ticketErrors) {
      errorObj[error._id] = ((_a = error.messages) == null ? void 0 : _a[0]) || "";
    }
    this.ticketErrors = errorObj;
  }
};

export {
  CheckoutException
};
//# sourceMappingURL=chunk-6OEHVXB7.mjs.map